export default __webpack_public_path__ + "static/media/Icon-rail.cbafb322.svg";